'use client';

import { c as _c } from "react/compiler-runtime";
import { AdvancedMarker, InfoWindow, useAdvancedMarkerRef } from '@vis.gl/react-google-maps';
import { Link } from '@/components/Link';
import { Typography } from '@/components/Typography';
import { PhosphorIcon } from '@/components/icons/PhosphorIcon';
import type { CmsMapMarker } from '@/services/cms-sdk';
export interface JucyMapBranchMarkerProps {
  branch: CmsMapMarker;
  activeMarker?: google.maps.marker.AdvancedMarkerElement;
  setActiveMarker?: (marker?: google.maps.marker.AdvancedMarkerElement) => void;
}
export function BranchMapMarker(t0) {
  const $ = _c(22);
  const {
    branch,
    activeMarker,
    setActiveMarker
  } = t0;
  const [markerRef, marker] = useAdvancedMarkerRef();
  let t1;
  if ($[0] !== branch.latitude || $[1] !== branch.longitude) {
    t1 = {
      lat: branch.latitude,
      lng: branch.longitude
    };
    $[0] = branch.latitude;
    $[1] = branch.longitude;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== marker || $[4] !== setActiveMarker) {
    t2 = () => setActiveMarker?.(marker || undefined);
    $[3] = marker;
    $[4] = setActiveMarker;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== markerRef || $[7] !== t1 || $[8] !== t2) {
    t3 = <AdvancedMarker ref={markerRef} position={t1} onClick={t2} />;
    $[6] = markerRef;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== activeMarker || $[11] !== branch.address || $[12] !== branch.latitude || $[13] !== branch.link || $[14] !== branch.longitude || $[15] !== branch.title || $[16] !== marker || $[17] !== setActiveMarker) {
    t4 = activeMarker === marker ? <InfoWindow headerContent={<Typography as="div" variant="h4" className="-mt-3">{branch.title}</Typography>} maxWidth={300} className="bg-white rounded-lg shadow-lg p-4 pl-0" anchor={marker} onCloseClick={() => setActiveMarker?.(undefined)}>{branch.address ? <Typography>{branch.address}</Typography> : null}{branch.link ? <Typography as={Link} href={branch.link}>Location details <PhosphorIcon name="caret-right" /></Typography> : null}<Link className="block mt-4 text-primary hover:underline" rel="noopener noreferrer" target="_blank" href={`https://www.google.co.nz/maps/dir/My+Location/${branch.latitude},${branch.longitude}`}>Get Directions <PhosphorIcon name="arrow-up-right" /></Link></InfoWindow> : null;
    $[10] = activeMarker;
    $[11] = branch.address;
    $[12] = branch.latitude;
    $[13] = branch.link;
    $[14] = branch.longitude;
    $[15] = branch.title;
    $[16] = marker;
    $[17] = setActiveMarker;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  if ($[19] !== t3 || $[20] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  return t5;
}